export function KToNumber(value: number) {
  return value * 1000;
}

export function NumberToK(value: number) {
  return value / 1000;
}
